export default {
  title: 'Tritt unserem Reward Club bei!',
  form: {
    phone_number: {
      label: 'Deine Handynummer',
      description: 'Wir brauchen das, um sicherzustellen, dass du die richtige Person bist, die wir belohnen.',
      placeholder: 'Handynummer',
    },
    birthday: {
      label: 'Geburtstag: Tag und Monat reichen für ein Geburtstagsgeschenk! 🥳',
      placeholder: 'Geburtstag (optional)',
      parts: {
        month: 'Monat',
        day: 'Tag',
      },
    },
  },
  benefits: {
    earn_points: 'Sammle Punkte bei jeder Bestellung',
    get_deals: 'Erhalte exklusive Angebote',
    redeem_points: 'Löse Punkte für Rabatte ein',
  },
  terms:
    'Mit der Anmeldung erklärst du dich mit unseren <TermsLink>Geschäftsbedingungen</TermsLink> einverstanden und stimmst unserer <PrivacyPolicyLink>Datenschutzrichtlinie</PrivacyPolicyLink> zu.',
  buttons: {
    continue: 'Weiter',
  },
  toasts: {
    login_success: 'Du hast dich erfolgreich eingeloggt',
    invalid_code: 'Ungültiger Code. Bitte versuche es erneut.',
    failed_to_update_profile: 'Profil kann nicht aktualisiert werden. Bitte versuche es erneut.',
  },
};
